import { ChevronLeftIcon, ChevronRightIcon, MagnifyingGlassIcon, TrophyIcon } from '@heroicons/react/24/outline'
import classnames from 'classnames'
import PropTypes from 'prop-types'
import { PureComponent } from 'react'
import { connect } from 'react-redux'
import { Link } from 'react-router-dom'
import { Button } from 'semantic-ui-react'

import { trackEvent } from 'global-utils/Analytics'
import { BASE_URL as searchURL } from 'search'
import System from 'system'

import { authAction, authLogout } from 'actions/AuthActions'

import ChangePassword from '../modals/ChangePassword'
import Login from '../modals/Login'
import Register from '../modals/Register'
import ResetPassword from '../modals/ResetPassword'
import SystemMessage from '../modals/SystemMessage'
import Notifications from '../users/notifications/Notifications'
import RegisterNow from './RegisterNow'

const onGoBack = (e) => {
  e.preventDefault()
  e.stopPropagation()
  System.history.goBack()
}

const onGoForward = (e) => {
  e.preventDefault()
  e.stopPropagation()
  System.history.goForward()
}

class Header extends PureComponent {
  componentDidMount() {
    if (System.msg && System.msg.token) {
      System.msg.logout = false
      this.props.authLogout()
      this.props.authAction('password')
    }
  }

  forceReloading = (e) => {
    const { onToggleMenu, smallDevice } = this.props
    if (smallDevice) {
      e.preventDefault()
      e.stopPropagation()
      onToggleMenu()
    } else if (document.location.pathname === '/') {
      document.location = '/'
    }
  }

  onLoginClick = () => {
    trackEvent('Navigation', 'Click', 'Main Menu - Login Button')
    this.props.authAction('login')
  }

  onModalClose = () => this.props.authAction(null)

  onRegisterClick = () => {
    trackEvent('Navigation', 'Click', 'Main Menu - Register Button')
    this.props.authAction('register')
  }

  renderModal() {
    const { action, message } = this.props
    if (message && message.show) {
      return <SystemMessage message={message} onClose={this.onModalClose} />
    }
    if (action === 'reset') {
      return <ResetPassword onClose={this.onModalClose} open />
    }
    if (action === 'login') {
      return <Login onClose={this.onModalClose} open />
    }
    if (action === 'register') {
      return <Register className="register" onClose={this.onModalClose} open />
    }
    if (action === 'password') {
      return (
        <ChangePassword
          className="password"
          comment={System.msg.content}
          onClose={this.onModalClose}
          open
          title={System.msg.title}
        />
      )
    }
    return null
  }

  renderSiteOptions = () => [
    <Button key="login" basic inverted onClick={this.onLoginClick}>
      Ingreso
    </Button>,
    <Button key="signup" onClick={this.onRegisterClick} primary>
      Registro
    </Button>,
  ]

  render() {
    const { smallDevice, user } = this.props

    return (
      <div
        className={classnames(
          'MainMenu fixed h-[var(--header-height)] w-full bg-white z-[101]',
          smallDevice ? 'bottom-0' : 'top-0',
          smallDevice ? 'px-3 py-1' : 'p-2',
        )}
        data-dark-mode="true"
      >
        {!user && <RegisterNow />}
        {this.renderModal()}
        <div className="flex h-full gap-2 px-1 mx-auto my-0 max-w-screen-1366 *:!text-text overflow-hidden">
          <Link className="shrink flex items-center h-full" onClick={this.forceReloading} to="/">
            <img
              alt="SweatBits"
              className="h-full"
              src={`${System.url}${smallDevice ? '/img/sb-tiny.png' : '/img/sweatbits.png'}`}
            />
          </Link>
          <div className="grow flex justify-center gap-2 *:!text-text">
            {smallDevice && (
              <Link className="flex items-center" onClick={onGoBack} to="/">
                <ChevronLeftIcon className="size-8" />
              </Link>
            )}
            {smallDevice && (
              <Link className="flex items-center" onClick={onGoForward} to="/">
                <ChevronRightIcon className="size-8" />
              </Link>
            )}
          </div>
          {user && (
            <Link className="flex items-center" to={smallDevice ? '/tournaments' : '/'}>
              <TrophyIcon className="size-7" />
            </Link>
          )}
          <Link className="flex items-center" to={searchURL}>
            <MagnifyingGlassIcon className="size-8" />
          </Link>
          <Notifications />
          {!user && this.renderSiteOptions()}
        </div>
      </div>
    )
  }
}

Header.propTypes = {
  authAction: PropTypes.func.isRequired,
  authLogout: PropTypes.func.isRequired,
  message: PropTypes.object.isRequired,
  onToggleMenu: PropTypes.func.isRequired,
  smallDevice: PropTypes.bool.isRequired,

  action: PropTypes.string,
  user: PropTypes.object,
}

Header.defaultProps = {
  action: null,
  user: null,
}

export default connect(
  (state) => ({
    action: state.auth.action,
    message: state.message,
    smallDevice: !!(state.environment?.device?.mobile || state.environment?.stage?.small),
    user: state.auth.usr,
  }),
  { authAction, authLogout },
)(Header)
